import React from 'react';
import { IconProps } from '../types';
const MinecraftBreezeRod: React.FC<IconProps> = ({ size = 24, className, style }) => (
<svg width={size} height={size} className={className} style={style} viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
<rect x="12" y="1" width="1" height="1" fill="rgba(87, 108, 157, 255)" />
<rect x="13" y="1" width="1" height="1" fill="rgba(62, 94, 135, 255)" />
<rect x="11" y="2" width="1" height="1" fill="rgba(87, 108, 157, 255)" />
<rect x="12" y="2" width="1" height="1" fill="rgba(181, 165, 202, 255)" />
<rect x="13" y="2" width="1" height="1" fill="rgba(122, 130, 196, 255)" />
<rect x="14" y="2" width="1" height="1" fill="rgba(47, 82, 127, 255)" />
<rect x="10" y="3" width="1" height="1" fill="rgba(87, 108, 157, 255)" />
<rect x="11" y="3" width="1" height="1" fill="rgba(191, 175, 201, 255)" />
<rect x="12" y="3" width="1" height="1" fill="rgba(122, 130, 196, 255)" />
<rect x="13" y="3" width="1" height="1" fill="rgba(62, 94, 135, 255)" />
<rect x="9" y="4" width="1" height="1" fill="rgba(87, 108, 157, 255)" />
<rect x="10" y="4" width="1" height="1" fill="rgba(191, 175, 201, 255)" />
<rect x="11" y="4" width="1" height="1" fill="rgba(149, 141, 211, 255)" />
<rect x="12" y="4" width="1" height="1" fill="rgba(62, 94, 135, 255)" />
<rect x="8" y="5" width="1" height="1" fill="rgba(87, 108, 157, 255)" />
<rect x="9" y="5" width="1" height="1" fill="rgba(181, 165, 202, 255)" />
<rect x="10" y="5" width="1" height="1" fill="rgba(122, 130, 196, 255)" />
<rect x="11" y="5" width="1" height="1" fill="rgba(62, 94, 135, 255)" />
<rect x="7" y="6" width="1" height="1" fill="rgba(87, 108, 157, 255)" />
<rect x="8" y="6" width="1" height="1" fill="rgba(181, 165, 202, 255)" />
<rect x="9" y="6" width="1" height="1" fill="rgba(122, 130, 196, 255)" />
<rect x="10" y="6" width="1" height="1" fill="rgba(62, 94, 135, 255)" />
<rect x="6" y="7" width="1" height="1" fill="rgba(87, 108, 157, 255)" />
<rect x="7" y="7" width="1" height="1" fill="rgba(191, 175, 201, 255)" />
<rect x="8" y="7" width="1" height="1" fill="rgba(122, 130, 196, 255)" />
<rect x="9" y="7" width="1" height="1" fill="rgba(62, 94, 135, 255)" />
<rect x="5" y="8" width="1" height="1" fill="rgba(87, 108, 157, 255)" />
<rect x="6" y="8" width="1" height="1" fill="rgba(191, 175, 201, 255)" />
<rect x="7" y="8" width="1" height="1" fill="rgba(122, 130, 196, 255)" />
<rect x="8" y="8" width="1" height="1" fill="rgba(47, 82, 127, 255)" />
<rect x="4" y="9" width="1" height="1" fill="rgba(87, 108, 157, 255)" />
<rect x="5" y="9" width="1" height="1" fill="rgba(181, 165, 202, 255)" />
<rect x="6" y="9" width="1" height="1" fill="rgba(122, 130, 196, 255)" />
<rect x="7" y="9" width="1" height="1" fill="rgba(47, 82, 127, 255)" />
<rect x="3" y="10" width="1" height="1" fill="rgba(87, 108, 157, 255)" />
<rect x="4" y="10" width="1" height="1" fill="rgba(191, 175, 201, 255)" />
<rect x="5" y="10" width="1" height="1" fill="rgba(122, 130, 196, 255)" />
<rect x="6" y="10" width="1" height="1" fill="rgba(47, 82, 127, 255)" />
<rect x="2" y="11" width="1" height="1" fill="rgba(87, 108, 157, 255)" />
<rect x="3" y="11" width="1" height="1" fill="rgba(191, 175, 201, 255)" />
<rect x="4" y="11" width="1" height="1" fill="rgba(122, 130, 196, 255)" />
<rect x="5" y="11" width="1" height="1" fill="rgba(47, 82, 127, 255)" />
<rect x="1" y="12" width="1" height="1" fill="rgba(62, 94, 135, 255)" />
<rect x="2" y="12" width="1" height="1" fill="rgba(181, 165, 202, 255)" />
<rect x="3" y="12" width="1" height="1" fill="rgba(122, 130, 196, 255)" />
<rect x="4" y="12" width="1" height="1" fill="rgba(62, 94, 135, 255)" />
<rect x="1" y="13" width="1" height="1" fill="rgba(108, 118, 171, 255)" />
<rect x="2" y="13" width="1" height="1" fill="rgba(149, 141, 211, 255)" />
<rect x="3" y="13" width="1" height="1" fill="rgba(62, 94, 135, 255)" />
<rect x="1" y="14" width="1" height="1" fill="rgba(47, 82, 127, 255)" />
<rect x="2" y="14" width="1" height="1" fill="rgba(62, 94, 135, 255)" />
</svg>);
export default MinecraftBreezeRod;